import PropTypes from 'prop-types'

const CardRatingHeaderRight = ({reviewDate, actions}) => {
  return (
    <div className="mt-CardRating-headerRight">
      <time className="mt-CardRating-date" dateTime={reviewDate}>
        {reviewDate}
      </time>
      {actions}
    </div>
  )
}

CardRatingHeaderRight.displayName = 'CardRatingHeaderRight'

CardRatingHeaderRight.propTypes = {
  reviewDate: PropTypes.string.isRequired,
  actions: PropTypes.node
}

export default CardRatingHeaderRight
